"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core/");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const get_1 = __importDefault(require("lodash/get"));
const omit_1 = __importDefault(require("lodash/omit"));
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
require("./../singleExpert/components/expertBlocks/licenses/licenses.scss");
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const editProps = [
    {
        name: "State",
        key: "state",
        autocomplete: true,
        dataKey: 'states'
    },
    {
        name: "Bar ID Number",
        key: "license_id",
        multiline: false,
    },
    [
        {
            name: "Month",
            key: "month",
            autocomplete: true,
            dataKey: 'months'
        },
        {
            name: "Year",
            key: "year",
            autocomplete: true,
            dataKey: 'years'
        }
    ]
];
const ExpertLicense = (props) => {
    const { open, editableLicense } = props;
    const { license, index } = editableLicense;
    const [isEdit, setEdit] = react_1.default.useState(false);
    const onEdit = (e, key) => {
        const val = e.target.value;
        props.updateLicense({ key, val });
    };
    const updateIterator = (fields) => {
        for (const prop of fields) {
            if (Array.isArray(prop)) {
                updateIterator(prop);
            }
            else {
                props.editExpert({ key: `blocks.certs.${index}.${prop.key}`, val: license[prop.key] });
            }
        }
    };
    const closeModal = () => {
        props.updateLicense({ index: null, license: null });
        props.triggerModal({ key: 'experts.license', val: false });
    };
    const update = () => {
        updateIterator(editProps);
        props.editExpert({ key: `blocks.certs.${index}.type`, val: 'license' });
        closeModal();
    };
    const generateField = (p) => {
        const { val, key, license, index } = p;
        if (val.autocomplete) {
            return react_1.default.createElement(Autocomplete_1.default, { key: key, value: get_1.default(license, val.key), inputValue: get_1.default(license, val.key), closeIcon: react_1.default.createElement("span", { style: { fontSize: "16px" }, className: "color-medium-gray" },
                    react_1.default.createElement(Clear_1.default, { fontSize: "inherit", color: "inherit" })), popupIcon: react_1.default.createElement("span", { className: "color-medium-gray" },
                    react_1.default.createElement(ExpandMore_1.default, { color: "inherit" })), onChange: (e, v) => {
                    if (e) {
                        props.updateLicense({ key: val.key, val: v || '' });
                    }
                }, options: get_1.default(props, val.dataKey), renderInput: (params) => react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: val.name, variant: "outlined" })) });
        }
        return react_1.default.createElement(core_1.TextField, { variant: "outlined", key: key, onChange: (e) => onEdit(e, val.key), margin: "dense", id: `${index}_${val.key}`, multiline: val.multiline, label: val.name, type: "text", disabled: val.readonly, defaultValue: get_1.default(license, val.key), fullWidth: true });
    };
    const handleDelete = () => {
        props.editExpert({ key: `blocks.certs.${index}.deleted`, val: true });
        closeModal();
    };
    const init = () => {
        const isEdit = (license && Object.values(omit_1.default(license, ['type'])).filter(val => !!val).length > 0) || false;
        setEdit(isEdit);
    };
    //const isEdit = (license && Object.values(_omit(license, ['type'])).filter(val => !!val).length) || false;
    return (react_1.default.createElement(core_1.Dialog, { open: open, maxWidth: 'sm', fullWidth: true, className: "expert-license-modal", onEnter: () => init(), onClose: () => closeModal() },
        react_1.default.createElement(core_1.DialogTitle, { id: "form-dialog-title" }, isEdit ? 'Edit Bar Number' : 'Add Bar Number'),
        open && react_1.default.createElement(core_1.DialogContent, { className: "expert-license-modal-open" }, license && editProps.map((val, key) => {
            return Array.isArray(val) ? react_1.default.createElement(core_1.Grid, { key: key, container: true, spacing: 3, className: "mt-5" }, val.map((v, k) => {
                return (react_1.default.createElement(core_1.Grid, { key: k, item: true, xs: 6 }, generateField({
                    val: v,
                    key: k,
                    license,
                    index
                })));
            })) : generateField({ val, key, license, index });
        })),
        react_1.default.createElement("div", { className: "modal-bottom" },
            isEdit &&
                react_1.default.createElement("div", { className: " profile-action-box" },
                    react_1.default.createElement(core_1.Button, { onClick: handleDelete, disableRipple: true, className: "profile-delete" }, "Delete")) || react_1.default.createElement("div", null),
            react_1.default.createElement(core_1.DialogActions, { className: 'btn-group expert-modal-footer-button-group' },
                react_1.default.createElement(core_1.Button, { color: "primary", className: 'v2-btn v2-btn-primary', onClick: () => update() }, "Save"),
                react_1.default.createElement(core_1.Button, { onClick: () => closeModal(), color: "secondary", className: 'v2-btn v2-btn-tertiary' }, "Never Mind")))));
};
const mapStateToProps = (state) => {
    const { modals, experts, staticData } = state;
    return {
        open: modals.ADMIN.experts.license,
        expert: experts.editableExpert,
        editableLicense: experts.editableLicense,
        years: staticData.yearsList,
        states: staticData.states.map(v => v.name),
        months: staticData.months
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        updateLicense: (data) => dispatch(expertsSlice_1.updateLicense(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertLicense);
